import { User } from '@src/entities/User/ui/components/User';
import { Button } from '@src/shared/ui/components/Button';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import React from 'react';

/**
 * CreateWithCriteria
 *
 * Renders a button that when clicked will navigate to the create action path screen with the supplied criteria.
 *
 * @param children
 * @param criteria
 * @returns {Element}
 * @constructor
 */
export function CreateWithCriteria({ children, criteria = {} }) {
  const router = useRouter();

  return (
    <ErrorHandler location="src/features/ActionPaths/Creation/components/buttons/CreateWithCriteria/CreateWithCriteria.jsx">
      <User.Capability attributes={['create']} resource="ActionPaths">
        <Button
          before={<IconSymbol icon="edit" variant="outlined" />}
          data-testid="create-button"
          onClick={async (event) => {
            event?.preventDefault();
            const encodedCriteria = Buffer.from(JSON.stringify(criteria)).toString('base64');
            router?.navigate(`/action-paths/0/create/automatic/draft/step/1/${encodedCriteria}`);
          }}
          variant="solid"
        >
          {children}
        </Button>
      </User.Capability>
    </ErrorHandler>
  );
}
